<template lang="pug">
  .padre
    .title
      span KPIs de recursos humanos
    .display-flex.fdc
      .rrhh.display-flex.fdr.space-evenly.flex-wrap(v-if="perfilVacaciones === 'recursos humanos'")
        .card-component(v-if="showCantidadPermisosSinAprobarRRHH" @click="redirigir('permisos-aprobar-rrhh')")
          cantidad-permisos-sin-aprobar-rrhh(@close="close('showCantidadPermisosSinAprobarRRHH')")
        .card-component(v-if="showCantidadContratosSinFirmar" @click="redirigir('reporte-contratos', true)")
          cantidad-contratos-sin-firmar(@close="close('showCantidadContratosSinFirmar')")
        .card-component(v-if="showCantidadDocumentosSinFirmar" @click="redirigir('reporte-documentos-firmar', true)")
          cantidad-documentos-sin-firmar(@close="close('showCantidadDocumentosSinFirmar')")
        .card-component(v-if="showCantidadBoletasSinVisualizar" @click="redirigir('boletas-reporte', true)")
          cantidad-boletas-sin-visualizar(@close="close('showCantidadBoletasSinVisualizar')")
    .contenedor-chart(v-if="perfilVacaciones === 'recursos humanos'")
      top-empleados-mas-dias-disponibles.flex-1
      cantidad-solicitudes-v-pendiente-aprobar-jefe.flex-1
    template(v-if="perfilVacaciones === 'recursos humanos'")
      empleados-por-areas.flex-1(
        :isHorizontal="true"
      )
</template>

<script>
import EmpleadosPorArea from './kpis/c_kpi_empleado_por_areas';
import CantidadSolicitudesVPendienteAprobarJefe from './kpis/c_kpi_solicitudes_v_pendiente_aprobar_jefe';
import TopEmpleadosMasDiasDisponibles from './kpis/c_kpi_top_empleados_mas_dias_disponibles';
import CantidadContratosSinFirmar from './kpis/c_kpi_cantidad_contratos_sin_firmar';
import CantidadDocumentosSinFirmar from './kpis/c_kpi_cantidad_documentos_sin_firmar';
import CantidadPermisosSinAprobarRRHH from './kpis/c_kpi_cantidad_permisos_sin_aprobar_rrhh';
import CantidadBoletasSinVisualizar from './kpis/c_kpi_cantidad_boletas_sin_visualizar';

export default {
  name: 'Dashboard',
  components: {
    'empleados-por-areas':EmpleadosPorArea,
    'cantidad-solicitudes-v-pendiente-aprobar-jefe':CantidadSolicitudesVPendienteAprobarJefe,
    'top-empleados-mas-dias-disponibles':TopEmpleadosMasDiasDisponibles,
    'cantidad-boletas-sin-visualizar':CantidadBoletasSinVisualizar,
    'cantidad-permisos-sin-aprobar-rrhh':CantidadPermisosSinAprobarRRHH,
    'cantidad-documentos-sin-firmar':CantidadDocumentosSinFirmar,
    'cantidad-contratos-sin-firmar':CantidadContratosSinFirmar
  },
  data () {
    return {
      perfilVacaciones:localStorage.getItem('perfilVacaciones'),
      isHorizontal: false,
      showCantidadBoletasSinVisualizar : true,
      showCantidadPermisosSinAprobarRRHH : true,
      showCantidadDocumentosSinFirmar : true,
      showCantidadContratosSinFirmar : true
    }
  },
  computed: {
    closeComponentUsuario () {
      return !this.showCantidadMisDocumentosSinFirmar && !this.showCantidadMisContratosSinFirmar && !this.showCantidadMisBoletasSinVisualizar
    }
  },
  methods:{
    redirigir (to, isQuery) {
      var objPush = { path: `/${to}` }
      if (isQuery) {
        let queryParamsValues = {
          'reporte-contratos': { firmado : 0 },
          'reporte-documentos-firmar': { estado : 1 },
          'boletas-reporte': { visto:0, anio:'all', mes:'all', tipo:'all' }
        }
        objPush.query = queryParamsValues[to]
      }
      this.$router.push(objPush)
    },
    handleResize () {
      if (window.innerWidth <= 820) {
        this.$store.dispatch('setSidebarDesktop', true)
        localStorage.setItem('sidebar-show', true)
      } else if (window.innerWidth < 1140) {
        this.$store.dispatch('setSidebarDesktop', false)
        localStorage.setItem('sidebar-show', false)
      }
    },
    close (componente) {
      this[componente] = false
    }
  }
};
</script>

<style lang="stylus" scoped>
/* Puedes agregar estilos personalizados aquí si es necesario */
.padre
  display flex
  flex-direction column
  box-sizing border-box
  .title
    padding-right: 12px;
    padding-left: 12px;
    font-size 16px
    span
      font-weight bold
      text-transform uppercase
  .card-component
    margin-top 10px
    margin-right 10px
  .contenedor-chart
    display flex
@media (max-width 1200px)
  .padre
    .contenedor-chart
      display: block
@media (max-width 428px)
  .padre
    .card-component
      margin-right 0px
      width 100%
      >>> .cuadro
        width 100%

</style>



// WEBPACK FOOTER //
// Component_Dashboard_KPI.vue?4778a5e8